import { render, staticRenderFns } from "./VeganPage.vue?vue&type=template&id=d38ef092&scoped=true&"
import script from "./VeganPage.vue?vue&type=script&lang=js&"
export * from "./VeganPage.vue?vue&type=script&lang=js&"
import style0 from "./VeganPage.vue?vue&type=style&index=0&id=d38ef092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38ef092",
  null
  
)

export default component.exports